import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import fr from "./locales/fr.json";
import en from "./locales/en.json";

const SUPPORTED = ["fr", "en"];

i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        resources: {
            fr: { translation: fr },
            en: { translation: en },
        },
        fallbackLng: "fr",
        supportedLngs: SUPPORTED,
        detection: {
            order: ["querystring", "localStorage", "navigator", "htmlTag"],
            lookupQuerystring: "lang",
            lookupLocalStorage: "cp_lang",
            caches: ["localStorage"],
        },
        interpolation: { escapeValue: false },
        returnEmptyString: false,
    });

// Sync <html lang="..."> on language change
const syncHtmlLang = (lng) => {
    const code = (lng || "fr").startsWith("en") ? "en" : "fr";
    document.documentElement.lang = code === "fr" ? "fr-FR" : "en";
};

i18n.on("languageChanged", syncHtmlLang);
syncHtmlLang(i18n.language);

export default i18n;
export { SUPPORTED };
